export default __webpack_public_path__ + "static/onboarding_a.9efa5088b746981cbc0a64bcf1f1f538.jpg";